// extracted by mini-css-extract-plugin
export default {"notFoundSection":"NotFound_notFoundSection__XDOo+","notFoundSectionContainer":"NotFound_notFoundSectionContainer__eXCT9","logo":"NotFound_logo__8wFPQ"};